<div class="flex flex-column pb-0">
    <div class="grid">
        <div class="col-6" *ngFor="let action of actions">
            <p-button
                [label]="action.isCopy && copied ? 'Copied!' : action.label"
                [severity]="action.isCopy && copied ? 'primary' : 'info'"
                [outlined]="!(action.isCopy && copied)"
                styleClass="p-button-icon-font-bold p-button-icon-font-2xl w-full text-left"
                class="share-modal-btn"
                [icon]="action.icon"
                (click)="onActionClick(action)"
            >
            </p-button>
        </div>
    </div>

    <div class="col-12 py-0">
        <p-divider />
    </div>

    <div class="col-12 flex-column align-items-center gap-2 px-6">
        <h3 class="m-0 text-center">Invite friends and earn rewards.</h3>
        <p class=" text-center">
            Share deals with your friends and get travel rewards when they signup for Dollar Flight Club
            <span class="underline cursor-pointer" (click)="clickLearnMore()">Learn more.</span>
        </p>
    </div>

    <div class="col-12 mt-3 px-6">
        <share-link-pill [link]="shareUrl"></share-link-pill>
    </div>
</div>
